export const countryToCurrencyMap: Record<string, string> = {
  AU: 'AUD',
  BE: 'EUR',
  BA: 'BAM',
  BG: 'BGN',
  CA: 'CAD',
  DK: 'DKK',
  FR: 'EUR',
  GE: 'GEL',
  DE: 'EUR',
  HK: 'HKD',
  IT: 'EUR',
  NL: 'EUR',
  NO: 'NOK',
  PL: 'PLN',
  RO: 'RON',
  RU: 'RUB',
  SE: 'SEK',
  CH: 'CHF',
  US: 'USD',
  GB: 'GBP'
}
